import React, { forwardRef } from 'react';
import { Snackbar, Alert } from '@mui/material';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/display-name
const SnackbarAlert = forwardRef((props, ref) => (
  <Alert elevation={6} ref={ref} {...props} />
));

const MuiSnackbar = ({
  snackbarIsOpen,
  closeSnackbar,
  info: { severity, message },
}) => (
  <Snackbar
    open={snackbarIsOpen}
    onClose={closeSnackbar}
    autoHideDuration={3000}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
  >
    <SnackbarAlert onClose={closeSnackbar} severity={severity}>
      {message}
    </SnackbarAlert>
  </Snackbar>
);

MuiSnackbar.propTypes = {
  snackbarIsOpen: PropTypes.bool,
  closeSnackbar: PropTypes.func,
  info: PropTypes.object,
};

export default MuiSnackbar;

// import React, { useState, forwardRef } from 'react';
// import { Box, Snackbar, Button, Alert } from '@mui/material';

// // eslint-disable-next-line react/display-name
// const SnackbarAlert = forwardRef((props, ref) => (
//   <Alert elevation={6} ref={ref} {...props} />
// ));

// const MuiSnackbar = () => {
//   const [open, setOpen] = useState(false);

//   const openSnackbar = () => setOpen(true);

//   const closeSnackbar = (e, reason) => {
//     if (reason === 'clickaway') return;
//     setOpen(false);
//   };

//   return (
//     <Box>
//       <Button onClick={openSnackbar}> Submit</Button>
//       <Snackbar
//         open={open}
//         onClose={closeSnackbar}
//         autoHideDuration={3000}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <SnackbarAlert onClose={closeSnackbar} severity="success">
//           Form submitted successfully!
//         </SnackbarAlert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default MuiSnackbar;
